export default "__VITE_ASSET__BFIXIK6U__"